import Factory from "../Factory";
import { FactoryInterface } from "../FactoryInterface";
import { Conversation } from "../Entities/Conversation/Conversation";
import { ConversationInterface } from "../Entities/Conversation/ConversationInterface";
import { MessageInterface } from "../Entities/Message/MessageInterface";
import MessageFactory from "./MessageFactory";
import EventFactory from "./EventFactory";
import { AttachmentInterface } from "../Entities/Attachment/AttachmentInterface";
import AttachmentFactory from "./AttachmentFactory";

class ConversationFactory extends Factory implements FactoryInterface {
  public create(data: any): ConversationInterface {
    const messages: MessageInterface[] = !!data.messages && data.messages.map(message => message?.id && MessageFactory.create(message));
    const attachments: AttachmentInterface[] = AttachmentFactory.createFromArray(data.attachments);

    return new Conversation({
      id: data.id,
      agencyId: data.agencyId,
      createdAt: data.createdAt ? new Date(data.createdAt) : null,
      createdBy: data.createdBy,
      updatedAt: data.updatedAt ? new Date(data.updatedAt) : null,
      updatedBy: data.updatedBy,
      removed: data.removed,
      statusId: data.statusId,
      typeId: data.typeId,
      propertyId: data.propertyId,
      unitId: data.unitId,
      chargeId: data.chargeId,
      contactId: data.contactId,
      eventId: data.eventId,
      event: data.event ? EventFactory.create(data.event) : null,
      messages: messages || [],
      existsUnreadMessages: data.existsUnreadMessages,
      notificationChannels: data.notificationChannels,
      attachments: attachments
    });
  };

  public reinitialize(data: any): ConversationInterface {
    return new Conversation({
      ...data
    });
  }
}

export default new ConversationFactory();
